import { Box, Modal, Typography, useTheme, IconButton } from '@mui/material';
import { useTranslation } from '../../hooks/useTranslation';
import { tokens } from '../../theme';
import { Button } from '../../components/Button';
import { ArrowRightAltOutlined } from '@mui/icons-material';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from 'react-router';

const ModalInfo = ({ open, onClose }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();

  const handleContinue = () => {
    onClose?.();
  };

  const handleBuyCredits = () => {
    onClose?.();
    setTimeout(() => navigate('/app/redutoconsultas'), 0);
  };

  const handleAccessConsult = () => {
    onClose?.();
    setTimeout(() => navigate('/app/redscore'), 0);
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 2,
      }}
    >
      <Box
        sx={{
          backgroundColor: '#fff',
          borderRadius: '16px',
          border: `2px solid ${colors.greenAccent[500]}`,
          p: { xs: '40px 24px', sm: '56px 64px' },
          maxWidth: 560,
          width: '100%',
          boxShadow: '0 24px 64px rgba(0,0,0,0.3)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '24px',
          outline: 'none',
          textAlign: 'center',
          position: 'relative',
          animation: 'fadeSlideUp 0.35s ease',
          '@keyframes fadeSlideUp': {
            from: { opacity: 0, transform: 'translateY(24px)' },
            to: { opacity: 1, transform: 'translateY(0)' },
          },
        }}
      >
        {/* Botão de fechar */}
        <IconButton
          onClick={onClose}
          sx={{
            position: 'absolute',
            top: 12,
            right: 12,
            color: colors.grey[400],
            '&:hover': { color: colors.grey[100] },
          }}
        >
          <CloseIcon />
        </IconButton>

        <Box
          sx={{
            width: 72,
            height: 72,
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: colors.greenAccent[500],
          }}
        >
          <WarningAmberOutlinedIcon sx={{ fontSize: 64 }} />
        </Box>

        <Typography variant="h3" fontWeight={700} sx={{ color: colors.grey[100] }}>
          {t('onboarding.info.title')}
        </Typography>

        <Typography
          variant="body1"
          sx={{ color: colors.grey[400], lineHeight: 1.7, maxWidth: 380 }}
        >
          {t('onboarding.info.subtitle')}
        </Typography>

        <Typography
          variant="body1"
          sx={{ color: colors.grey[400], lineHeight: 1.7, maxWidth: 380 }}
        >
          {t('onboarding.info.description')}
        </Typography>

        <Button
          fullWidth
          onClick={handleAccessConsult}
          sx={{
            color: '#fff',
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Box component="span" sx={{ flex: 1, textAlign: 'center' }}>
            {t('onboarding.info.accessConsult').toUpperCase()}
          </Box>
          <ArrowRightAltOutlined sx={{ position: 'absolute', right: 16 }} />
        </Button>

        <Button
          fullWidth
          variant="outlined"
          onClick={handleBuyCredits}
          sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >
          {t('onboarding.info.buyCredits').toUpperCase()}
        </Button>
      </Box>
    </Modal>
  );
};

export default ModalInfo;
